import { render, staticRenderFns } from "./stateOfGoods.vue?vue&type=template&id=00aa6cc9&"
import script from "./stateOfGoods.vue?vue&type=script&lang=js&"
export * from "./stateOfGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports